import { render, staticRenderFns } from "./PracticeList.vue?vue&type=template&id=be045cb8&scoped=true"
import script from "./PracticeList.vue?vue&type=script&lang=ts"
export * from "./PracticeList.vue?vue&type=script&lang=ts"
import style0 from "./PracticeList.vue?vue&type=style&index=0&id=be045cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be045cb8",
  null
  
)

export default component.exports